import React, { Component } from "react";
import {websiteUrl} from "../../utils/common";

const PlayBack = (props) => 
{ 
     const wEBURL=websiteUrl(); 
     //const strUrl=`https://login.avtbharat.com/Playback.html?VehicleNO=${props.Routeobj.vehicleno} &Trip_ID=${props.Routeobj.Tripno}&fromDate=${props.Routeobj.FromDate}`;
     const strUrl=wEBURL+`Playback.html?VehicleNO=${props.Routeobj.vehicleno} &Trip_ID=${props.Routeobj.Tripno}&fromDate=${props.Routeobj.FromDate}`;
    
    // alert(strUrl);

     return ( 
      <>
                     
       <iframe width="1030px" height="800px" src={strUrl}  title="" ></iframe>  
       </>       
      )}; 
   
export default PlayBack;
